import { useState } from "react";

import useResizeObserver from "./useResizeObserver";

const useHeight = (ref) => {
  const [height, setHeight] = useState(ref.current?.clientHeight);

  useResizeObserver(ref, () => {
    const newHeight = ref.current?.clientHeight;
    if (height !== newHeight) setHeight(newHeight);
  });

  return height;
};

export default useHeight;
